import {useQuery} from '@apollo/react-hooks';
import {NetworkStatus} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAvailabilityReport as GetAvailabilityReportQuery,
    GetAvailabilityReportVariables,
} from 'nutshell-graphql-types';

import GET_AVAILABILITY_REPORT from '../queries/get-availability-report.graphql';

export function useGetAvailabilityReport(
    meetingId: string,
    periodString: string = 'm-2 TO d',
    skip: boolean = false
) {
    const {data, error, loading, refetch, networkStatus} = useQuery<
        GetAvailabilityReportQuery,
        GetAvailabilityReportVariables
    >(GET_AVAILABILITY_REPORT, {
        variables: {meetingId, periodString},
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        skip,
    });

    const report = data?.availabilityReport ?? null;
    const isChangingInput = networkStatus === NetworkStatus.setVariables;

    return {
        report,
        isLoading: loading && (!data || isChangingInput),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
